import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';


export const fetchAbsentTeachers = createAsyncThunk(
  "substitutes/fetchAbsentTeachers",
  async ({ date, school_id }, thunkAPI) => {
    const state = thunkAPI.getState();
    const userId = state.authSlice?.user?.id;
const isIndividualLogin = state.authSlice?.user.roles === 'teacher' || state.authSlice?.user.roles === 'guest_user';
    const response = await api.get(
      "/substitutes/absent",
      {
        params: {
          date,
          school_id,
          ...(userId && isIndividualLogin && {
            user_id: userId,
          }),
        },
      }
    );

    return response.data;
  }
);

export const fetchTeacherPeriods = createAsyncThunk(
  "substitutes/fetchTeacherPeriods",
  async (
    { teacherId, date, school_id },
    thunkAPI
  ) => {
    const state = thunkAPI.getState();

    const user = state.authSlice?.user;
    const userId = user?.id;

    const isIndividualLogin =
      user?.roles === "teacher" ||
      user?.roles === "guest_user";

    const response = await api.get(
      `/substitutes/teacher-periods/${teacherId}/${date}/${school_id}`,
      {
        params: {
          ...(userId &&
            isIndividualLogin && {
              user_id: userId,
            }),
        },
      }
    );

    return response.data;
  }
);

export const fetchAlternativeTeachers = createAsyncThunk(
  "substitutes/fetchAlternativeTeachers",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();

    const user = state.authSlice?.user;
    const userId = user?.id;

    const isIndividualLogin =
      user?.roles === "teacher" ||
      user?.roles === "guest_user";

    const response = await api.post(
      `/substitutes/alternative-teachers/${data.school_id}`,
      data,
      {
        params: {
          ...(userId &&
            isIndividualLogin && {
              user_id: userId,
            }),
        },
      }
    );

    return response.data;
  }
);

export const markTeacherAbsent = createAsyncThunk(
  "substitutes/markTeacherAbsent",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();

    const user = state.authSlice?.user;
    const userId = user?.id;

    const isIndividualLogin =
      user?.roles === "teacher" ||
      user?.roles === "guest_user";

    try {
      const response = await api.post(
        "/substitutes/absent",
        data,
        {
          params: {
            ...(userId &&
              isIndividualLogin && {
                user_id: userId,
              }),
          },
        }
      );

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const updateSubstituteAssignment = createAsyncThunk(
  "substitutes/updateSubstituteAssignment",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();

    const user = state.authSlice?.user;
    const userId = user?.id;

    const isIndividualLogin =
      user?.roles === "teacher" ||
      user?.roles === "guest_user";

    const response = await api.put(
      "/substitutes/assignment",
      data,
      {
        params: {
          ...(userId &&
            isIndividualLogin && {
              user_id: userId,
            }),
        },
      }
    );

    return response.data;
  }
);

export const fetchSubstituteSheet = createAsyncThunk(
  "substitutes/fetchSubstituteSheet",
  async ({ date, school_id }, thunkAPI) => {
    const state = thunkAPI.getState();

    const user = state.authSlice?.user;
    const userId = user?.id;

    const isIndividualLogin =
      user?.roles === "teacher" ||
      user?.roles === "guest_user";

    const response = await api.get(
      `/substitutes/sheet/${date}/${school_id}`,
      {
        params: {
         
          ...(userId &&
            isIndividualLogin && {
              user_id: userId,
            }),
        },
      }
    );

    return response.data;
  }
);

const substituteSlice = createSlice({
  name: 'substitutes',
  initialState: {
    absentTeachers: [],
    teacherPeriods: [],
    alternativeTeachers: {
      sameSubjectTeachers: [],
      differentSubjectTeachers: []
    },
    substituteSheet: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTeacherPeriods: (state) => {
      state.teacherPeriods = [];
    },
    clearAlternativeTeachers: (state) => {
      state.alternativeTeachers = {
        sameSubjectTeachers: [],
        differentSubjectTeachers: []
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAbsentTeachers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAbsentTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.absentTeachers = action.payload;
      })
      .addCase(fetchAbsentTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTeacherPeriods.fulfilled, (state, action) => {
    if (!Array.isArray(state.teacherPeriods)) {
        state.teacherPeriods = [];
    }

    // Remove any old periods for this teacher
    state.teacherPeriods = state.teacherPeriods.filter(
        (p) => String(p.teacher_id) !== String(action.meta.arg.teacherId)
    );

    // Append new periods
    state.teacherPeriods = [
        ...state.teacherPeriods,
        ...action.payload,
    ];
  })
      .addCase(fetchAlternativeTeachers.fulfilled, (state, action) => {
        state.alternativeTeachers = action.payload;
      })
      .addCase(markTeacherAbsent.fulfilled, (state, action) => {
        state.absentTeachers.push(action.payload);
      })
        .addCase(markTeacherAbsent.rejected, (state, action) => {
        state.error = action.payload?.error || action.error.message;
      })
      .addCase(updateSubstituteAssignment.fulfilled, (state) => {
        // Refresh data after assignment update
      })
      .addCase(fetchSubstituteSheet.fulfilled, (state, action) => {
        state.substituteSheet = action.payload;
      });
  },
});

export const { clearTeacherPeriods, clearAlternativeTeachers } = substituteSlice.actions;
export default substituteSlice.reducer;
